import React from "react";
import PropTypes from "prop-types";
import PhoneInputComponent from "../input/PhoneInputComponent";
import UserDataService from "../../common/UserDataService";
import {setupOnExtractData} from "../../../util/FormUtil";

class PhoneNumberComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setExtractData = this.setExtractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    setExtractData(func){
        this.extractData = func;
    }

    render(){
        const {data, metadata, setFormState, userDataInit, userDataService, smsOnly, onError} = this.props;
        return (
            <div className="grid">
                <div className="grid__col-md-3 grid__col-sm-12">
                    Phone Number
                </div>
                <div className="grid__col-md-9 grid__col-sm-12">
                    <PhoneInputComponent
                        data={data}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        userDataService={userDataService}
                        onExtractData={this.setExtractData}
                        smsOnly={smsOnly}
                        onError={onError}
                    />
                </div>
            </div>
        );
    }
}

PhoneNumberComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    onExtractData: PropTypes.func,
    smsOnly: PropTypes.bool,
    onError: PropTypes.func.isRequired
};

export default PhoneNumberComponent;